// ======================================================
// materialTypeService.ts
// ======================================================

import { apiClient }
  from "../api/apiClient";

import {
  MaterialType,
  CreateMaterialTypeRequest,
  UpdateMaterialTypeRequest
} from "../interfaces/MaterialType";

// ======================================================
// RESPONSE DTO
// ======================================================

type ResponseDto<T> = {

  loggingHistoryID?: number;

  statusCode: number;

  isSuccess: boolean;

  message: string;

  errors?: string[];

  data?: T;

  dataList?: T[];
};

// ======================================================
// MATERIAL TYPE SERVICE
// ======================================================

export const materialTypeService = {

  // ====================================================
  // GET ALL
  // ====================================================

  getAll: async (): Promise<
    ResponseDto<MaterialType>
  > => {

    const response =
      await apiClient.get<
        ResponseDto<MaterialType>
      >(
        "/MaterialTypes/GetAll"
      );

    return response.data;
  },

  // ====================================================
  // GET BY ID
  // ====================================================

  getById: async (
    materialTypeID: number
  ): Promise<
    ResponseDto<MaterialType>
  > => {

    const response =
      await apiClient.get<
        ResponseDto<MaterialType>
      >(
        `/MaterialTypes/GetById/${materialTypeID}`
      );

    return response.data;
  },

  // ====================================================
  // CREATE
  // ====================================================

  create: async (
    payload: CreateMaterialTypeRequest
  ): Promise<
    ResponseDto<MaterialType>
  > => {

    const response =
      await apiClient.post<
        ResponseDto<MaterialType>
      >(
        "/MaterialTypes/Create",
        payload
      );

    return response.data;
  },

  // ====================================================
  // UPDATE
  // ====================================================

  update: async (
    payload: UpdateMaterialTypeRequest
  ): Promise<
    ResponseDto<MaterialType>
  > => {

    const response =
      await apiClient.put<
        ResponseDto<MaterialType>
      >(
        `/MaterialTypes/Update/${payload.materialTypeID}`,
        payload
      );

    return response.data;
  },

  // ====================================================
  // DELETE
  // ====================================================

 delete: async (
  materialTypeID: number
): Promise<ResponseDto<any>> => {

  const response =
    await apiClient.delete<
      ResponseDto<any>
    >(
      `/MaterialTypes/Delete/${materialTypeID}`
    );

  // RETURN FULL RESPONSE DATA
  return response.data;
}
};